import React from 'react';
import { motion } from 'framer-motion';
import { X, CheckCircle } from 'lucide-react';

const RegistrationModal = ({ isOpen, onClose, userType }) => {
  if (!isOpen) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="bg-white rounded-lg p-8 max-w-md w-full"
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900">Registration Successful</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500">
            <X className="h-6 w-6" />
          </button>
        </div>
        <div className="text-center mb-6">
          <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
          <p className="text-lg text-gray-700">
            Thank you for registering with LoadLink as a {userType}!
          </p>
        </div>
        <div className="space-y-4">
          <h3 className="font-semibold text-lg">What's Next:</h3>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>Your account is pending approval by our admin team.</li>
            <li>We'll review your information within 1-2 business days.</li>
            <li>Once approved, you'll receive an email confirmation.</li>
            <li>After approval, you can log in and start using LoadLink.</li>
          </ul>
        </div>
        <button
          onClick={onClose}
          className="mt-8 w-full bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 transition duration-300"
        >
          Got it, thanks!
        </button>
      </motion.div>
    </motion.div>
  );
};

export default RegistrationModal;